import {
  DESKTOP_MAX_PRODUCTS_PER_PAGE,
  MOBILE_MAX_PRODUCTS_PER_PAGE,
} from '@/constants/pagination-default-limits';
import { Cookie } from '@/types/storage';

import { useCookies } from '@/hooks/use-cookies';
import { DeviceType } from '@/types/types';

export const getPaginationLimit = (limit?: number): number => {
  const deviceType = useCookies(Cookie.DEVICE_TYPE);

  if (
    limit &&
    limit !== DESKTOP_MAX_PRODUCTS_PER_PAGE &&
    limit !== MOBILE_MAX_PRODUCTS_PER_PAGE
  ) {
    return limit;
  } else {
    return deviceType === DeviceType.MOBILE
      ? MOBILE_MAX_PRODUCTS_PER_PAGE
      : DESKTOP_MAX_PRODUCTS_PER_PAGE;
  }
};
